<script>
import { camelToTitleCase } from "@bloglovin/vue-framework";

export default {
  name: "BaseComponent",
  components: {
  },
  inject: ["appName"],
  props: {
  },
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
    resolveSpacingOverrides(size, spacingType, sides = ["top", "bottom", "left", "right"]) {
      const spacingOverrides = {};
      sides.forEach(side => {
        spacingOverrides[`${spacingType}${camelToTitleCase(side)}`] = size;
      });
      return spacingOverrides;
    },
  },
};
</script>
